import { useEffect, useState } from 'react'
import React from 'react'
import { Container, Card, Row, Col, Button } from 'react-bootstrap'
import { FaUserCircle, FaArrowLeft } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'

const TeacherProfile = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [institutes, setInstitutes] = useState([])
  const navigate = useNavigate()

  const { id } = useParams()
  console.log('ID:', id)

  const location = useLocation()
  // const teacher = location.state?.teacher
  const [teacher, setTeacher] = useState(location.state?.teacher || null)

  console.log('Teachers data:', teacher)
  useEffect(() => {
    const institueId = Cookies.get('institute_id')

    if (!teacher && id && institueId) {
      ApiEndpoints.getAllTeachers({ institute_id: Number(institueId) })
        .then((res) => {
          if (Array.isArray(res.data.data)) {
            const matchedTeacher = res.data.data.find(
              (t) => String(t.id) === String(id),
            )
            if (matchedTeacher) {
              setTeacher(matchedTeacher)
            } else {
              console.error('No teacher found with ID:', id)
            }
          }
        })
        .catch((err) => {
          console.error('Failed to fetch teachers:', err)
        })
    }
  }, [id, teacher])

  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data)
      } else {
        setInstitutes([])
      }
    })
  }, [])
  useEffect(() => {
    const storedInstitute = Cookies.get('institute_name')
    if (storedInstitute) {
      setInstitutes([{ name: storedInstitute }])
    }
  }, [])
  if (!teacher) {
    return <p>No teacher data available.</p>
  }

  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }
  const handleBack = () => {
    navigate('/TeacherList')
  }

  const handleIdCard = () => {
    navigate(`/TeacherIdcard/${id}`, { state: { teacher } })
  }
  return (
    <div style={{ marginLeft }}>
      {teacher && id ? (
        <>
          <div
            className="container-fluid p-0"
            style={{
              marginTop: window.innerWidth < 768 ? '55px' : '-12px',
            }}
          >
            <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
              <div className="m-0">
                <h2 className="mb-0">
                  <span
                    className="text-warning
                  "
                  >
                    {teacher.name}
                  </span>
                  's Profile
                </h2>
              </div>
              <Button
                variant="outline-light"
                className=" border-white"
                onClick={handleBack}
              >
                <FaArrowLeft /> Go to Teacher List
              </Button>
            </div>
          </div>
          <Container className="mt-4">
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <Row className="align-items-center text-center text-md-start">
                  <Col md={2} className="text-center mt-4 mb-2">
                    <img
                      src={teacher?.teacher_image || '/studentprofile.jpg'}
                      className="rounded-circle border border-3"
                      alt="Profile"
                      width="100"
                      height="100"
                    />
                  </Col>
                  <Col md={8}>
                    <h4 className="mb-0">
                      {teacher?.name.toUpperCase() || 'N/A'}
                    </h4>
                  </Col>
                </Row>

                <Row className="d-flex align-items-center justify-content-between">
                  <Col>
                    <h4 className="text-primary mt-4 mb-4 text-start">
                      General Information
                    </h4>
                  </Col>
                  <Col className="text-end">
                    <Button onClick={handleIdCard}>Print ID Card</Button>
                  </Col>
                </Row>
                <Row className="g-3">
                  {[
                    {
                      label: 'Institute Name',
                      value: institutes.find(
                        (i) => i.institute_id === teacher.institute_id,
                      )?.name,
                    },
                    { label: 'Email Address', value: teacher?.email },
                    { label: 'Gender', value: teacher?.gender },
                    { label: 'Birth Date', value: teacher?.dob },
                    { label: 'Age', value: calculateAge(teacher?.dob) },
                    { label: 'Address', value: teacher?.address },
                    { label: 'Qualification', value: teacher?.qualification },
                    { label: 'Joining Date', value: teacher?.joining_date },
                    { label: 'Phone Number', value: teacher?.phone },
                    {
                      label: 'Status',
                      value: (
                        <span
                          className={
                            teacher?.status?.toLowerCase() === 'active'
                              ? 'text-success'
                              : 'text-danger'
                          }
                        >
                          {' '}
                          {teacher?.status.charAt(0).toUpperCase() +
                            teacher.status.slice(1).toLowerCase() || 'N/A'}{' '}
                        </span>
                      ),
                    },
                  ].map((item, idx) => (
                    <Col md={3} xs={6} key={idx}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">{item.label}</small>
                        <p className="mb-0 text-break">{item.value || 'N/A'}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </>
      ) : (
        <p>Loading student teacher...</p>
      )}
    </div>
  )
}

export default TeacherProfile
